import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faSort, faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import types from './Types'
import _ from 'lodash'
import loadingSvg from '../../media/loading.svg'
import { filter } from 'rxjs/operators'

const CheckboxHeader = (props) => {
  const tableName= props._tableName
  return (
    <div className=' flex justify-center'>
      <input
        type="checkbox"
        //checked={checked}
        onChange={e => {
          const elements = document.getElementsByClassName(tableName)
          for (let element of elements) {
            element.checked = e.currentTarget.checked
          }
          Dispatch.nextAction('table.checkbox.onchange', tableName)
        }}
    />
    </div>
  )
}

const Header = (props) => {
  const name = props._name
  const field = props._field
  const sortable = props._sortable
  const order = (props.table?.sortBy?.field === field) ? props.table?.sortBy?.order : null
  return (
    <div className='flex items-center'>
      <div> {name} </div>
      {sortable && _.isNil(order) && <div className='pl2 f5 moon-gray pointer'
        onClick={e => Dispatch.nextAction('table.sortBy', {field: field, order: 'desc'})}
        ><FontAwesomeIcon className='' icon={faSort} /></div> }
      {sortable && (order === 'asc') && <div className='pl2 f5 dark-gray pointer'
        onClick={e => Dispatch.nextAction('table.sortBy', {field: field, order: 'desc'})}
        ><FontAwesomeIcon className='' icon={faCaretUp} /></div> }
      {sortable && (order === 'desc') && <div className='pl2 f5 dark-gray pointer'
        onClick={e => Dispatch.nextAction('table.sortBy', {field: field, order: 'asc'})}
        ><FontAwesomeIcon className='' icon={faCaretDown} /></div> }
    </div>
  )
}

const Table = (props) => {
  const tableName = props._tableName ?? 'generic'
  const noOverflow = props._noOverflow ? '' :  ' overflow-y-auto '
  const shipments = props._shipments
  const loading = props._loading ?? false
  const columns = props._columnLayout ?? []
  const hasGroupHeaders = columns.reduce((acc,next) => acc ? true : (next.groupHeader ? true : false), false)
  const groupHeaders = columns.reduce((acc,next) => {
      if (_.last(acc)?.id === next.groupHeader) {
        const clone = [...acc]
        clone[acc.length > 0 ? acc.length - 1 : 0] = { id: acc[acc.length > 0 ? acc.length - 1 : 0]?.id, length: (acc[acc.length > 0 ? acc.length - 1 : 0]?.length ?? 0) + 1, style: next.style}
        return clone
      }
      else {
        return [...acc, { id: next.groupHeader, length: 1, color: next.style }]
      }
    
  }, [])
  const gridTemplateColumns = columns.reduce((acc,next) => acc + (next.width ? ' ' + next.width : ' auto'), '')
  return (
    <div className={'w-100 ' + noOverflow} style={{maxHeight: props.ui?.window?.height - props.ui?.window?.header - 50}}>
      {(loading) &&
        <div className='h5 w-100 flex justify-center'>
          <img className='w4' src={loadingSvg} alt='loading'></img>
        </div>
      }
      {/* Note: shipments.length will actually show string length and array length */}
      {!loading &&
        <div className='w-100 pb3 ' style={{
          
          display: 'grid',
          gridTemplateColumns
          }}>
            {
              hasGroupHeaders && groupHeaders.map((header, index) => {
                const gridColumnEnd = header?.length && 'span ' + header?.length
                return (
                  <div
                    key={header?.id}
                    className={ 'pa2 fw7 f6 dark-gray bg-light-gray bt b--moon-gray tc br ' + (index === 0 ? ' bl ' : '') + (header.style ? ' ' + header.style + ' ' : '')} 
                    style={{ gridColumnEnd, position: 'sticky', top: 0 }}>
                      {header?.id}
                  </div>
                )
              })
            }
            {
              columns.map((column, index) => {
                return (
                    <div key={column.field} className={'pa2 mb2 fw7 f6 dark-gray bg-light-gray bb bt b--moon-gray br ' + (index === 0 ? ' bl ' : '') + (column.style ? ' ' + column.style + ' ' : '')} style={{position: 'sticky', top: (hasGroupHeaders ? 33 : 0)}}>{column.type === 'checkbox' ? <CheckboxHeader _tableName={tableName} {...props} /> : <Header _name={column.header} _field={column.field} _sortable={column.sortable} {...props}/>}</div>
                )
              })
            }
            {shipments?.map((shipment, index) => {
              return (
                <>
                  {
                    columns.map(column => {
                      if (_.isNil(types[column.type])){
                        throw Error("CUSTOMER ERROR: Type in Table Undefined: " + column.type)
                      }
                      const Type = types[column.type] ?? Text
                      return (
                        <div key={shipment.id + column.field} 
                          className={'pv1 f6 fw4 flex items-center ' + (index%2 === 1 ? ' bg-light-gray ' : '') + (column.fieldStyle ? ' ' + column.fieldStyle + ' ' : '')} 
                          style={{}}>
                          <Type 
                            _tableName={tableName} 
                            _value={_.get(shipment, column.field)} 
                            _id={shipment.id} 
                            _field={column.field} 
                            _childClass={column.childClass} 
                            _preText={column.preText} 
                            _onClick={column.onClick} {...props} 
                          />
                        </div>
                      )
                    })
                  }
                </>
              )
            })}

        </div>
      }
      {!loading &&  shipments?.length === 0 &&
        <div className='w-100 pv5 bt b--moon-gray flex justify-center items-center tc'>No Data to Display</div>
      }
      {props._loadMore && shipments?.length > 99 &&
          <SubmitButton id={'loadmore'} className='' 
              defaultChild={ props => (
                <div className='pt2 pb4 w-100 flex justify-center'>
                  <div className='fw6 f6 pointer' onClick={e => Dispatch.nextAction('shipments.loadMore')}>Load More</div>
                </div>
              )}
              loadingChild={ props => (
                <div className='pt2 pb4 w-100 flex justify-center'>
                  <div className='mh3 ' style={{width:28}}>
                    <img src={loadingSvg} alt='loading'/>
                  </div>
                </div>
              )}
              errorChild={ props => (
                <div className='pl3 f7 fw4 red tr pointer'>Error</div>
              )}
              loadingStream={
                Dispatch.getAction('Request.shipmentsLoadMore')
                }
              successStream={
                Dispatch.getAction('Response.shipmentsLoadMore')
                  .pipe(
                    filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.shipments) ))),
                  )
                }
              errorStream={
                Dispatch.getAction('Response.shipmentsLoadMore')
                  .pipe(
                    filter(e => !_.isNil(e.errors)),
                  )}
            />
      }
    </div>
  )
}

export default Table